import { useTranslation } from 'react-i18next'

import { FileUploadFormField } from '@/components/form/file-upload-form-field'
import { getAssetLink } from '@/helpers/get-asset-link'
import { Building } from '@/reducers/types'

interface GeneralPhotoFieldProps {
  building: Building
  name: 'image' | 'logo'
}

export const GeneralPhotoField = ({ building, name }: GeneralPhotoFieldProps) => {
  const { t } = useTranslation(['organisation'])
  const existing = name === 'logo' ? building.logo : building.image

  return (
    <FileUploadFormField
      acceptedTypes={['JPG', 'JPEG', 'PNG']}
      existingImageUrl={
        existing ? getAssetLink({ file: existing, path: 'chitown-building' }) : undefined
      }
      layout="maximized"
      maxFiles={1}
      multiple={false}
      name={name}
      uploadLabel={t(
        name === 'logo'
          ? 'organisation:places.create.logo.uploadLabel'
          : 'organisation:places.general.photo.uploadLabel',
      )}
    />
  )
}
